<template>
  <div id="builder"></div>
</template>

<script>
import TemplateBuilder from "./components/TemplateBuilder/index";

export default {
  name: "VueTemplateBuilder",
  props: {
    container: {
      type: [String, HTMLElement], // Updated to allow both string and HTMLElement
      required: true
    },
    secretKey: {
      type: String,
      required: true
    },
    publicApiKey: {
      type: String,
      required: true
    },
    platformName: {
      type: String,
      required: false
    },
    templateGalleryModal: {
      type: Boolean,
      required: false
    },
    createTemplateRoute: {
      type: String,
      required: false
    },
    templateBuilderRoute: {
      type: String,
      required: false
    },
    olcTemplate: {
      type: Object,
      required: false
    },
    designerTemplateQuery: {
      type: Object,
      required: false
    },
    sandbox: {
      type: Boolean,
      required: false
    },
    allowSenderFields: {
      type: Boolean,
      required: false
    },
    allowPropertyFields: {
      type: Boolean,
      required: false
    },
    excludedFields: {
      type: String,
      default: null,
      required: false,
    },
    designerQueryAmount: {
      type: String | Number,
      default: null,
      required: false,
    },
    allowedAddOns: {
      type: [String],
      default: null,
      required: false,
    },
    allowedTemplateSections:{ 
      type: [String],
      default: null,
      required: false,
    },
    env: {
      type: String,
      default: null,
      required: false,
    },
    restrictedProducts: {
      type: [Number],
      default: null,
      required: false,
    },
    currentTheme: {
      type: String,
      default: null,
      required: false,
    },
    disallowedProducts: {
      type: [String],
      default: null,
      required: false,
    },
    propertyOfferCost: {
      type: Number,
      default: null,
      required: false,
    },
    customPropertyOfferCost: {
      type: Number,
      default: null,
      required: false,
    },
    gsvCost: {
      type: Number,
      default: null,
      required: false,
    },
    allowAdditionalPage: {
      type: Boolean,
      required: false
    },
     showTemplateTypesPage: {
      type: Boolean,
      required: false
    },
    onReturnAndNavigate: {
      type: Function,
      required: false
    },
    onCreateCustomTemplateQuery: {
      type: Function,
      required: false
    },
    onGetOneTemplate: {
      type: Function,
      required: false
    },
    onGetTemplates: {
      type: Function,
      required: false
    },
    onGetCustomFields: {
      type: Function,
      required: false
    },
    onDuplicateTemplate: {
      type: Function,
      required: false
    },
    onGetBrandingImages: {
      type: Function,
      required: false
    },
    onDeleteBrandingImage: {
      type: Function,
      required: false
    },
    onUploadBrandingImage: {
      type: Function,
      required: false
    },
    onGetQRCodes: {
      type: Function,
      required: false
    },
    onDeleteQRCodes: {
      type: Function,
      required: false
    },
    onUploadQRCode: {
      type: Function,
      required: false
    },
    onEditQRCode: {
      type: Function,
      required: false
    },
    onSubmit: {
      type: Function,
      required: false,
    },
    styles: {
      type: Object,
      required: false,
    }
  },
  data() {
		return {
			templateBuilderVueInstance: null,
		};
	},
  mounted() {
    let vm = this;
    console.log('vm', vm);
    this.initializeEditor(vm);
  },
  // eslint-disable-next-line vue/no-deprecated-destroyed-lifecycle
  destroyed() {
    this.templateBuilderVueInstance.destroy();
  },

  methods: {
    initializeEditor(props) {
      this.templateBuilderVueInstance = TemplateBuilder({
        container: document.getElementById(props.container) || document.getElementById('builder'),
        secretKey: props.secretKey,
        publicApiKey: props.publicApiKey,
        platformName: props.platformName,
        templateGalleryModal: props.templateGalleryModal,
        createTemplateRoute: props.createTemplateRoute,
        templateBuilderRoute: props.templateBuilderRoute,
        olcTemplate: props.olcTemplate,
        designerTemplateQuery: props.designerTemplateQuery,
        sandbox: props.sandbox,
        allowSenderFields: props.allowSenderFields,
        allowPropertyFields: props.allowPropertyFields,
        excludedFields: props.excludedFields,
        designerQueryAmount: props.designerQueryAmount,
        allowedAddOns: props.allowedAddOns,
        allowedTemplateSections: props.allowedTemplateSections,
        env: props.env,
        restrictedProducts: props.restrictedProducts,
        disallowedProducts: props.disallowedProducts,
        propertyOfferCost: props.propertyOfferCost,
        customPropertyOfferCost: props.customPropertyOfferCost,
        gsvCost: props.gsvCost,
        allowAdditionalPage: props.allowAdditionalPage,
        showTemplateTypesPage: props.showTemplateTypesPage,
        currentTheme: props.currentTheme,
        onReturnAndNavigate: props.onReturnAndNavigate, 
        onCreateCustomTemplateQuery: props.onCreateCustomTemplateQuery,
        onGetOneTemplate: props.onGetOneTemplate,
        onGetTemplates: props.onGetTemplates,
        onGetCustomFields: props.onGetCustomFields,
        onDuplicateTemplate: props.onDuplicateTemplate,
        onGetBrandingImages: props.onGetBrandingImages,
        onDeleteBrandingImage: props.onDeleteBrandingImage,
        onGetQRCodes: props.onGetQRCodes,
        onUploadBrandingImage: props.onUploadBrandingImage,
        onUploadQRCode: props.onUploadQRCode,
        onDeleteQRCodes: props.onDeleteQRCodes,
        onEditQRCode: props.onEditQRCode,
        onSubmit: props.onSubmit,
        styles: props.styles,
      });
    }
  }
};
</script>